import {Loading} from 'components/ui/Loading'
import styles from './LoadingPage.scss'

export const LoadingPage = () => (
  <div className={styles.loading}>
    <Loading />
  </div>
)
